module.exports = __webpack_public_path__ + "img/separator7.b083bda3.svg";